export class BrandingModel {
  public instanceHashId: string;
  public companyHashId: string;
  public notificationFile?: string;
  public expandedWebMenuFile?: string;
  public collapsedWebMenuFile?: string;
  public mobileAppFile?: string;
  public brandingColorList: BrandingColorList[];
}

export class BrandingColorList {
  public template: string;
  public type: string;
  public color: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/branding/models/branding.model.ts